import { render, staticRenderFns } from "./ListaAlmacen.vue?vue&type=template&id=d0dad858&"
import script from "./ListaAlmacen.vue?vue&type=script&lang=js&"
export * from "./ListaAlmacen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports